<template>
  <div
    class="week-calendar-day-column"
    :style="{ height: `${calendarHeight}px` }"
  >
    <div class="week-calendar-grid">
      <div
        v-for="slot in timeSlots"
        :key="`grid-${day.date}-${slot.key}`"
        class="week-calendar-grid-cell"
        :class="{ 'week-calendar-grid-cell--half': slot.isHalf }"
        :style="{ height: `${slotHeight}px` }"
      />
    </div>
    <div class="week-calendar-events">
      <div
        v-for="group in eventGroups"
        :key="group.key"
        class="week-calendar-event-group"
        :style="group.style"
      >
        <week-calendar-event
          v-for="event in group.events"
          :key="event.key"
          :appointment="event.appointment"
          :event-key="event.key"
          :event-date="event.date"
          :style="event.style"
          :can-drag="canDragAppointment(event.appointment)"
          :is-active-drag="isDraggingAppointment(event.appointment)"
          :is-saving="isSavingAppointment(event.appointment)"
          @pointerdown="onEventPointerDown"
          @deleteMultipleAppointments="$emit('deleteMultipleAppointments', $event)"
          @openModalInsuranceList="$emit('openModalInsuranceList', $event)"
          @openModalExpenses="$emit('openModalExpenses', $event)"
          @infoWaitingList="$emit('infoWaitingList')"
        />
      </div>
    </div>
    <div
      v-if="currentTimeStyle"
      class="week-calendar-current-time-line"
      :style="currentTimeStyle"
    />
  </div>
</template>

<script>
import WeekCalendarEvent from './WeekCalendarEvent.vue';

export default {
  name: 'WeekCalendarDayColumn',
  components: {
    WeekCalendarEvent,
  },
  props: {
    day: {
      type: Object,
      required: true,
    },
    calendarHeight: {
      type: Number,
      required: true,
    },
    slotHeight: {
      type: Number,
      required: true,
    },
    timeSlots: {
      type: Array,
      required: true,
    },
    eventGroups: {
      type: Array,
      default: () => [],
    },
    currentTimeStyle: {
      type: Object,
      default: null,
    },
    canDragAppointment: {
      type: Function,
      required: true,
    },
    isDraggingAppointment: {
      type: Function,
      required: true,
    },
    isSavingAppointment: {
      type: Function,
      required: true,
    },
  },
  methods: {
    onEventPointerDown(event, calendarEvent) {
      this.$emit('event-pointerdown', event, calendarEvent);
    },
  },
};
</script>

<style lang="scss">
@import 'src/assets/scss/variables';

.week-calendar-day-column {
  position: relative;
  background-color: $bg-color-dark;
  border-left: $border-width solid $border-color;
  border-radius: 0;
  overflow: visible;
  min-width: 0;
}

.week-calendar-grid {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  pointer-events: none;
}

.week-calendar-grid-cell {
  border-top: $border-width solid $border-color;
  flex: 0 0 auto;
}

.week-calendar-grid-cell--half {
  border-top-style: dotted;
}

.week-calendar-events {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: visible;
}

.week-calendar-event-group {
  position: absolute;
  width: 100%;
  left: 0;
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
}

.week-calendar-current-time-line {
  position: absolute;
  left: -10px;
  right: 0;
  pointer-events: none;
  z-index: 10;
  border-top: .08rem solid $error-color;
}
</style>
